import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Prüfe ob Cookies akzeptiert wurden
    const cookiesAccepted = localStorage.getItem('cookies-accepted');
    if (!cookiesAccepted) {
      // Kurz warten bevor Banner angezeigt wird
      const timer = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookies-accepted', 'true');
    setShowBanner(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookies-accepted', 'essential-only');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[60] bg-white border-t border-gray-200 shadow-2xl p-4 md:p-6">
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
          {/* Text */}
          <div className="flex-1">
            <h3 className="font-semibold text-[#032925] mb-1">Cookie-Einstellungen</h3>
            <p className="text-sm text-[#032925]/70">
              Wir verwenden nur technisch notwendige Cookies, um Ihnen die bestmögliche Nutzung unserer Website zu ermöglichen. 
              Weitere Informationen finden Sie in unserer{' '}
              <Link to="/datenschutz" className="text-[#b5a05f] hover:underline">
                Datenschutzerklärung
              </Link>.
            </p>
          </div>
          
          {/* Buttons */}
          <div className="flex flex-wrap gap-2">
            <button
              onClick={declineCookies}
              className="px-4 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors text-[#032925]"
            >
              Nur notwendige
            </button>
            <button
              onClick={acceptCookies}
              className="px-4 py-2 text-sm bg-[#032925] text-white rounded-lg hover:bg-[#3d3015] transition-colors"
            >
              Alle akzeptieren
            </button>
          </div>
          
          {/* Close Button */}
          <button
            onClick={declineCookies}
            className="absolute top-2 right-2 md:static p-1 text-gray-400 hover:text-gray-600"
            aria-label="Schließen"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
